/**
 * @namespace Stores
 * @category Stores
 * @module map-toolbox-store
 *
 *
 * This store is used mainly to track state of isCollapsed between components : Used to unbind switchable-popup-mixin if isCollapsed === true
 * */

const createState = () => ({
  viewName: '',
  isCollapsed: true,
})

export default {
  namespaced: true,
  state: createState(),
  getters: {
    viewName: (state) => state.viewName,
    isCollapsed: (state) => state.isCollapsed,
  },
  mutations: {
    reset(state) {
      Object.assign(state, createState())
    },
    setView(state, viewName) {
      state.viewName = viewName
    },
    setIsCollapsed(state, value) {
      state.isCollapsed = value
    },
  },
  actions: {
    reset({ commit }) {
      commit('reset')
    },
    setView({ commit }, viewName) {
      commit('setView', viewName)
    },
  },
}
